import Pusher from "pusher-js";
import { generateBaseUri } from "./helper";
import { createChannelAuthorization } from "./pusherAuth";

//mengaktifkan log pusher untuk debugging
// Pusher.logToConsole = true;

const pusher = new Pusher(import.meta.env.VITE_PUSHER_APP_KEY, {
  forceTLS: true,
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
  // userAuthentication: {
  //   endpoint: `${generateBaseUri()}/broadcasting/auth`,
  //   transport: "ajax",
  //   headers: getAuthorizationHeader(),
  // },
  // Token diambil saat auth (selalu terbaru), endpoint tidak mengirim X-App
  channelAuthorization: createChannelAuthorization(
    `${generateBaseUri()}/broadcasting/auth`,
    { "X-App": null }
  ),
});

// Fungsi untuk menginisialisasi kembali koneksi Pusher (auth channel otomatis pakai token terbaru)
export const reconnectPusher = () => {
  pusher.disconnect(); // Memutuskan koneksi Pusher
  pusher.connect();
};

export default pusher;
